import * as React from 'react';
import factorySvgIcon from './utils/factorySvgIcon';
const SvgUserFilled = (props) => {
    const { color } = props;
    return (React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18 8A6 6 0 1 1 6 8a6 6 0 0 1 12 0Zm3.932 12.731c.216.524-.106 1.051-.623 1.216V22H2.69v-.053c-.517-.165-.839-.692-.623-1.216C3.452 17.377 6.903 15 10.942 15h2.116c4.038 0 7.49 2.377 8.874 5.731Z", fill: color }));
};
export default factorySvgIcon(SvgUserFilled);
//# sourceMappingURL=SvgUserFilled.js.map